import { ApiSidebarItem, SidebarItem, SidebarItemStatus } from "@core/types/sidebar.type";
import { KeycloakService } from "@ogs/ngx-keycloak";
import { inject } from "@angular/core";
import { Permission } from "@shared/types/permission.types";

function resolveSidebarStatus (apiItem: ApiSidebarItem, kc: KeycloakService): SidebarItemStatus {
  let missingPermissions: Permission[] | undefined;

  if (apiItem.permissions) {
    const requiredPermissions: Permission[] = apiItem.permissions;

    missingPermissions = requiredPermissions.filter((p: Permission): boolean => !kc.hasAccessTokenResourceAccess(p.resource, p.role));
  }

  return { active: apiItem.active ?? true, missingPermissions };
}

export function apiToDomain (apiItems: ApiSidebarItem[] | null, kc: KeycloakService = inject(KeycloakService)): SidebarItem[] | null {
  if (!apiItems)
    return null;

  return apiItems.map((i: ApiSidebarItem): SidebarItem => {
    const _status: SidebarItemStatus = resolveSidebarStatus(i, kc);

    return {
      id: i.id,
      status: _status,
      items: i.items ? apiToDomain(i.items, kc) ?? undefined : undefined,
      text: i.text,
      icon: i.icon,
      additionalIcon: i.additionalIcon,
      link: i.link,
      action: i.action,
      tokens: i.token ? i.token.split(",") : undefined
    };
  });
}
